import { PendoChoreographerPlugin, ProductIds, type envType } from '@atlassian/ipm-choreographer';

let pendoPlugin: PendoChoreographerPlugin | undefined;

export function getPendoPlugin(env: envType): PendoChoreographerPlugin {
	if (!pendoPlugin) {
		pendoPlugin = new PendoChoreographerPlugin(env, { sourceProductId: ProductIds.CONFLUENCE });
	}
	return pendoPlugin;
}
